import { appCreate } from './app/create';

const rootElement = document.getElementById('app');

if (rootElement) {
  appCreate(rootElement);
} else {
  // Fail silently on pages that aren't SPA-ready
}
